import Cookies from 'js-cookie';
import { getCustomerId } from '@js/utilities/trackingIdentity';

const getAffiliation = () => window.location.hostname;

export const getProductsArrayFromProductsDTO = (productsDTO) =>
    Object.keys(productsDTO).map((key) => productsDTO[key]);

export const getDLProductFromProductDTO = (product) => {
    const names = product.translation?.name?.split(':');

    const dlData = {
        // id of an item
        item_id: product.id,
        // name of an item
        item_name: names?.[0] || null,
        // store.id / dimain?
        affiliation: getAffiliation(),
        // index will be added in loop
        index: 0,
        // brand of an item
        item_brand: 'SAVICKI',
        // category name // TODO: get translation from backend
        item_category: product.feed_category || product.facet_type?.slug || null,
        // collection name // TODO: get translation from backend
        item_category2:
            product.facet_collection?.translation?.name || product.facet_collection?.slug || '',
        // product`s variant // TODO: get variant from backend
        item_variant: names?.[1] || null,
        // GA`s id of an listing
        // item_list_id: '',
        // GA`s name of an listing
        // item_list_name: '',
        // product`s price
        price: product.price?.value || null,
        // product`s quantity
        quantity: 1,
    };

    // discount (products with promotion only)
    if (product.old_price?.value) {
        dlData.discount = Number(product.old_price.value) - Number(product.price.value);
    }

    // subcategory name (jewellery only)
    if (product.root_facet_type?.slug === 'womensjewellery') {
        dlData.item_category_3 = product.facet_type?.slug || null;
    }

    // kafelek "showcase" - produkt niesprzedawalny wstawiony na listing.
    // Bez tego znacznika nie da sie odroznic jego odslon i klikniec od
    // zwyklych produktow, czyli nie da sie ocenic, czy wstawki maja sens.
    if (product.is_showcase) {
        dlData.is_showcase = true;
    }

    return dlData;
};

export const getDLProductFromCartProductDTO = (product) => {
    const dlData = {
        ...getDLProductFromProductDTO(product.purchasable),
        price: product.priceWithConfiguration?.value || product.price?.value,
        options: [
            // TODO: GET OPTIONS
        ],
    };

    return dlData;
};

export const getDLGlobalParams = () => {
    const AUTH_COOKIE_NAME = 'is_customer_logged';

    // console.log(Cookies.get(AUTH_COOKIE_NAME) ? 'logged_in' : 'logged_out');

    const params = {
        site_language: window.config.language.code,
        site_currency: window.config.currency.code,

        login_status: Cookies.get(AUTH_COOKIE_NAME) ? 'logged_in' : 'logged_out',
        user_is_lead: !!Cookies.get('user_is_lead'),
        user_is_customer: !!Cookies.get('user_is_customer'),
        content_group: window.config.resource.resourcable_type || 'other',
    };

    // id klienta, nie ciasteczko sesji (sesja nie moze wychodzic do GTM)
    params.user_id = params.login_status === 'logged_in' ? getCustomerId() : null;

    if (params.user_is_lead) {
        const leadSource = Cookies.get('user_lead_source');

        if (leadSource) {
            const sourceType = JSON.parse(leadSource).source_type;

            params.lead_source = sourceType;
        }
    }

    return params;
};
